export const layout = {
    maxWidth: 1024,
}

export const rootLevelBlock = {
    maxWidth: layout.maxWidth,
    width: "100%",
    margin: "0 auto",
    paddingLeft: "32px",
    paddingRight: "32px",
} as const
